import React, { useState, useEffect } from 'react';
import '../styles/BottomNav.css';

const BottomNav = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const contactSection = document.getElementById('contact');
      if (!contactSection) return;

      const rect = contactSection.getBoundingClientRect();

      // Check if the "Contact" section is visible in the viewport
      const isInView = rect.top < window.innerHeight && rect.bottom > 0;
      setIsVisible(isInView);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`bottom-nav ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="nav-icon">
        <a href="/" className="logo">
          <span className="logo-text">P</span>
        </a>
      </div>
      <div className="nav-links">
        <a
          href="https://drive.google.com/file/d/1kY0kgByfqG8Sth0tW1GlepvqIp5tYO1l/view?usp=sharing"
          className="nav-link"
        >
          <i className="fas fa-download"></i> Resume
        </a>
        <a
          href="https://github.com/PRATYUSHA1309"
          target="_blank"
          rel="noreferrer"
          className="nav-link"
        >
          <i className="fab fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/pratyushajangareddi"
          target="_blank"
          rel="noreferrer"
          className="nav-link"
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://www.behance.net/saipratyus"
          target="_blank"
          rel="noreferrer"
          className="nav-link"
        >
          <i className="fab fa-behance"></i>
        </a>
        <a href="mailto:jpratyu13@gmail.com" className="nav-link">
          <i className="fas fa-envelope"></i>
        </a>
      </div>
    </div>
  );
};

export default BottomNav;
